/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Analytics_Funnel_Stage_WithdrawnInputs */

const en_analytics_funnel_stage_withdrawn = /** @type {(inputs: Analytics_Funnel_Stage_WithdrawnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Withdrawn`)
};

const de_analytics_funnel_stage_withdrawn = /** @type {(inputs: Analytics_Funnel_Stage_WithdrawnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zurückgezogen`)
};

const fr_analytics_funnel_stage_withdrawn = /** @type {(inputs: Analytics_Funnel_Stage_WithdrawnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Retiré`)
};

const es_analytics_funnel_stage_withdrawn = /** @type {(inputs: Analytics_Funnel_Stage_WithdrawnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Retirado`)
};

const it_analytics_funnel_stage_withdrawn = /** @type {(inputs: Analytics_Funnel_Stage_WithdrawnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ritirata`)
};

const nl_analytics_funnel_stage_withdrawn = /** @type {(inputs: Analytics_Funnel_Stage_WithdrawnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Teruggetrokken`)
};

const pl_analytics_funnel_stage_withdrawn = /** @type {(inputs: Analytics_Funnel_Stage_WithdrawnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wycofano`)
};

const fi_analytics_funnel_stage_withdrawn = /** @type {(inputs: Analytics_Funnel_Stage_WithdrawnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Peruttu`)
};

const da_analytics_funnel_stage_withdrawn = /** @type {(inputs: Analytics_Funnel_Stage_WithdrawnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trukket tilbage`)
};

const sv_analytics_funnel_stage_withdrawn = /** @type {(inputs: Analytics_Funnel_Stage_WithdrawnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Återkallad`)
};

/**
* | output |
* | --- |
* | "Withdrawn" |
*
* @param {Analytics_Funnel_Stage_WithdrawnInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const analytics_funnel_stage_withdrawn = /** @type {((inputs?: Analytics_Funnel_Stage_WithdrawnInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Analytics_Funnel_Stage_WithdrawnInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_analytics_funnel_stage_withdrawn(inputs)
	if (locale === "fr") return fr_analytics_funnel_stage_withdrawn(inputs)
	if (locale === "es") return es_analytics_funnel_stage_withdrawn(inputs)
	if (locale === "it") return it_analytics_funnel_stage_withdrawn(inputs)
	if (locale === "nl") return nl_analytics_funnel_stage_withdrawn(inputs)
	if (locale === "pl") return pl_analytics_funnel_stage_withdrawn(inputs)
	if (locale === "fi") return fi_analytics_funnel_stage_withdrawn(inputs)
	if (locale === "da") return da_analytics_funnel_stage_withdrawn(inputs)
	if (locale === "sv") return sv_analytics_funnel_stage_withdrawn(inputs)
	return en_analytics_funnel_stage_withdrawn(inputs)
});